<template>
    <v-layout row>
        <v-flex xs12>
            <v-card class="px-3 pt-3 pb-5 px-md-5" flat style="height: 78vh">
                <h3 class="primary--text d-block mb-4" style="width: 100%;">Histórico de valores do último ano dos tipos</h3>
                <v-container fluid grid-list-sm white style="max-height: 50vh; overflow-y: auto;">
                    <v-data-table
                        :headers="headers"
                        :items="reajustes"
                        item-key="modalidadeId"
                        hide-actions
                        class="az-table-list tabela-ultimos-reajustes"
                        no-data-text="Não existem índices cadastrados."
                    >
                        <template v-slot:items="props">
                            <v-tooltip  v-if="!props.item.possuiReajuste" v-model="tooltipVisible[props.item.modalidadeId]" top>
                                <template v-slot:activator="{ on, attrs }">
                                    <tr :class="getRowClass(props.item)" v-on="on" v-bind="attrs" :key="props.item.modalidadeId">
                                        <td class="text-xs-left">{{ props.item.ano ? props.item.ano : '--' }}</td>
                                        <td class="text-xs-left">{{props.item.ano ? props.item.ano - 1 : '--'}}</td>
                                        <td class="text-xs-left">{{ props.item.tituloModalidade }}</td>
                                        <td class="text-xs-left">{{ props.item.valorBase | cdCurrency('R$ ', 2) }}</td>
                                        <td class="text-xs-left">{{ props.item.indicador ? props.item.indicador : '--' }}</td>
                                        <td class="text-xs-left">{{ props.item.valorAtualizado | cdCurrency('R$ ', 2) }}</td>
                                        <td class="text-xs-right">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon v-on="on"
                                                           @click="$emit('editarModalidade', props.item.modalidadeId)">
                                                        <v-icon color="grey">login</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Acessar Tipo</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </template>
                                <span>Não existe reajuste cadastrado para o tipo <strong>{{ props.item.tituloModalidade }}</strong></span>
                            </v-tooltip>
                            <tr v-else :class="getRowClass(props.item)" :key="props.item.modalidadeId"
                                @click.stop="$emit('editarModalidade', props.item.modalidadeId)" style="cursor: pointer;">
                                <td class="text-xs-left">{{ props.item.ano ? props.item.ano : '--' }}</td>
                                <td class="text-xs-left">{{ props.item.ano ? props.item.ano - 1 : '--' }}</td>
                                <td class="text-xs-left">{{ props.item.tituloModalidade }}</td>
                                <td class="text-xs-left">{{ props.item.valorBase | cdCurrency('R$ ', 2) }}</td>
                                <td class="text-xs-left">{{ props.item.indicador ? props.item.indicador : '--' }}</td>
                                <td class="text-xs-left">{{ props.item.valorAtualizado | cdCurrency('R$ ', 2) }}</td>
                                <td class="text-xs-right">
                                    <v-btn icon small @click.stop="$emit('editarModalidade', props.item.modalidadeId)">
                                        <v-icon aria-hidden="true" color="#777777" small>fas fa-sign-in-alt</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    name: 'ListarUltimosReajustesTodasModalidades',
    props: {
        reajustes: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            tooltipVisible: {},
            headers: [
                { text: 'Ano Base', value: 'anoBase', class: 'primary--text font-weight-black', height: '50px', sortable: false },
                { text: 'Ano Indicador', value: 'anoIndicador', class: 'primary--text font-weight-black', height: '50px', sortable: false },
                { text: 'Tipo', value: 'tituloTipo', class: 'primary--text font-weight-black', height: '50px', sortable: false },
                { text: 'Valor Base', value: 'valorBase', class: 'primary--text font-weight-black', height: '50px', sortable: false },
                { text: 'Indicador', value: 'indicador', class: 'primary--text font-weight-black', height: '50px', sortable: false },
                { text: 'Valor Atualizado', value: 'valorAtualizado', class: 'primary--text font-weight-black', height: '50px', sortable: false },
                { text: 'Ações', value: 'acoes', class: 'primary--text font-weight-black text-xs-right', height: '50px', sortable: false }
            ]
        }
    },
    methods: {
        getRowClass(item) {
            if (!item.possuiReajuste) {
                return 'warning-row'
            }
        }
    }
}
</script>

<style scoped lang="stylus">
    .warning-row {
        background-color: rgba(255, 213, 79, 0.07);
    }

    @media (max-width 720px)
        .v-data-table.tabela-ultimos-reajustes
            padding 0

        td
            text-align left

        td:nth-of-type(1):before
            content "Ano Base:"
            color var(--v-primary-base)

        td:nth-of-type(2):before
            content "Ano Indicador:"
            color var(--v-primary-base)

        td:nth-of-type(3):before
            content "Tipo:"
            color var(--v-primary-base)

        td:nth-of-type(4):before
            content "Valor Base:"
            color var(--v-primary-base)

        td:nth-of-type(5):before
            content "Indicador:"
            color var(--v-primary-base)

        td:nth-of-type(6):before
            content "Valor Atualizado:"
            color var(--v-primary-base)

        td:last-child:before
            content "Ações:"
            color var(--v-primary-base)
</style>